var _style, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1,
    cy: 59.9,
    r: 59.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.7,75.4L106.7,75.4L82,91.6c0.2-0.1,1.5,1.4,2.5,2.8c1,1.5,1.9,3.2,1.7,3.3l24.1-17.1l0,0 c1-0.8,1.1-2.5,0.1-3.9C109.4,75.3,107.8,74.7,106.7,75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,92.6c-2.7,1.3-3.4,0.2-7.8,3.2c-4.4,3-4.2,11.6-4.2,11.6s1.7-1.6,7.2-2.2c5.5-0.6,9.5-5.7,9.5-5.7 c0.4-0.3-0.4-2-1.7-3.9C81.3,93.7,80,92.4,79.6,92.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,28.3c-22.1,0-40.1,12.7-40.1,28.3S55.9,100,61.9,84.9C70.1,64.2,102,72.2,102,56.6S84,28.3,61.9,28.3z  M33.5,56.4c-2.2,0.2-4.1-1.4-4.4-3.5c-0.2-2.2,1.4-4.1,3.5-4.4c2.2-0.2,4.1,1.4,4.4,3.5C37.2,54.2,35.6,56.2,33.5,56.4z M45.5,36.1 c1.5-1.6,4.1-1.6,5.6,0c1.6,1.5,1.6,4.1,0,5.6c-1.5,1.6-4.1,1.6-5.6,0C44,40.2,44,37.6,45.5,36.1z M53,80.4 c-3.6,0.4-6.8-2.2-7.2-5.8c-0.4-3.6,2.2-6.8,5.8-7.2s6.8,2.2,7.2,5.8C59.2,76.8,56.6,80,53,80.4z M70.2,41c-2.2,0.2-4.1-1.4-4.3-3.6 c-0.2-2.2,1.4-4.1,3.6-4.3s4.1,1.4,4.3,3.6C74,38.8,72.4,40.8,70.2,41z M90.1,48.3c-0.8,2-3.2,3-5.2,2.1c-2-0.8-3-3.2-2.1-5.2 c0.8-2,3.2-3,5.2-2.1C90,44,91,46.3,90.1,48.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.fb6b70e00d28c6a39ede0f5c5b5cb90f.svg";
export { ForwardRef as ReactComponent };